import symbolOnly from '../assets/symbolOnly.svg';
import horizantal from '../assets/horizantal.svg';
import sequare from '../assets/sequare.svg';
import symbolOnly_light from '../assets/symbolOnly_light.svg';
import horizantal_light from '../assets/horizantal_light.svg';
import sequare_light from '../assets/sequare_light.svg';
import symbolOnly_lbg from '../assets/symbolOnly_lbg.svg';
import horizantal_lbg from '../assets/horizantal_lbg.svg';
import sequare_lbg from '../assets/sequare_lbg.svg';
import { Box, useTheme } from '@mui/material';

const AgLogos = ({
  type,
  background,
}: {
  type: 'symbolOnly' | 'horizantal' | 'sequare';
  background?: 'none' | 'light' | 'dark';
}) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        backgroundColor:
          background === 'dark' ? theme.palette.secondary.main : '',
      }}
    >
      <a href='https://agunity.com' target='_blank' rel='noopener noreferrer'>
        <img
          alt='AgUnity Logo'
          src={
            type === 'horizantal'
              ? background === 'dark'
                ? horizantal_light
                : background === 'light'
                ? horizantal_lbg
                : horizantal
              : type === 'sequare'
              ? background === 'dark'
                ? sequare_light
                : background === 'light'
                ? sequare_lbg
                : sequare
              : background === 'dark'
              ? symbolOnly_light
              : background === 'light'
              ? symbolOnly_lbg
              : symbolOnly
          }
        />
      </a>
    </Box>
  );
};

export default AgLogos;
